/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type change_requests_MedicalChangeField = {
    comment?: string;
    dosage?: string;
    id?: string;
    kind?: change_requests_MedicalChangeField.kind;
    name?: string;
    operation?: change_requests_MedicalChangeField.operation;
    type?: string;
};
export namespace change_requests_MedicalChangeField {
    export enum kind {
        DISEASE = 'disease',
        MEDICATION = 'medication',
    }
    export enum operation {
        ADD = 'add',
        UPDATE = 'update',
        REMOVE = 'remove',
    }
}

